export function initTabs() {
    if ($(".mdc-tab-bar").length) {
        $('a.mdc-tab').click(function (e) {
            e.preventDefault();

            const url = $(this).attr("href");
            if (url) {
                setTimeout(function () {
                    window.location.replace(url);
                }, 300);
            }
        });
    }
}